const indexItems = [
  { title: '国产剧', icon: 'ri-flag-2-line', desc: '热播新剧+经典回顾', count: '800+', color: 'primary' },
  { title: '韩剧', icon: 'ri-heart-pulse-line', desc: '高甜浪漫+悬疑惊悚', count: '300+', color: 'accent' },
  { title: '美剧', icon: 'ri-global-line', desc: '高分口碑+精校字幕', count: '200+', color: 'secondary' },
  { title: '日剧', icon: 'ri-sun-line', desc: '治愈温情+职场励志', count: '150+', color: 'primary' },
  { title: '泰剧', icon: 'ri-sailboat-line', desc: '清新浪漫+异域风情', count: '80+', color: 'accent' },
  { title: '古装剧', icon: 'ri-vip-crown-line', desc: '宫廷权谋+仙侠玄幻', count: '350+', color: 'secondary' },
  { title: '都市剧', icon: 'ri-building-2-line', desc: '职场情感+生活百态', count: '280+', color: 'primary' },
  { title: '悬疑剧', icon: 'ri-search-eye-line', desc: '烧脑推理+反转不断', count: '120+', color: 'accent' },
  { title: '动漫', icon: 'ri-rocket-line', desc: '热血番剧+国漫精品', count: '500+', color: 'secondary' },
];

function getColorClasses(color: string) {
  switch (color) {
    case 'accent':
      return {
        bg: 'bg-accent-50',
        border: 'border-accent-200/60',
        hoverBorder: 'hover:border-accent-400/50',
        iconBg: 'bg-accent-100',
        icon: 'text-accent-600',
        count: 'text-accent-600',
        hover: 'hover:bg-accent-50/50',
      };
    case 'secondary':
      return {
        bg: 'bg-secondary-50',
        border: 'border-secondary-200/60',
        hoverBorder: 'hover:border-secondary-400/50',
        iconBg: 'bg-secondary-100',
        icon: 'text-secondary-600',
        count: 'text-secondary-600',
        hover: 'hover:bg-secondary-50/50',
      };
    default:
      return {
        bg: 'bg-primary-50',
        border: 'border-primary-200/60',
        hoverBorder: 'hover:border-primary-400/50',
        iconBg: 'bg-primary-100',
        icon: 'text-primary-600',
        count: 'text-primary-600',
        hover: 'hover:bg-primary-50/50',
      };
  }
}

export default function IndexSection() {
  return (
    <section id="index" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <i className="ri-compass-3-line text-accent-400 text-xs"></i>
            <span className="text-accent-300 text-xs font-medium">追剧索引</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            全部分类 · 一网打尽
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            九大分类索引，快速找到你想看的每一部剧
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, i) => {
            const c = getColorClasses(item.color);
            return (
              <div
                key={i}
                className={`group relative p-4 md:p-5 rounded-xl border transition-all duration-300 cursor-pointer ${c.bg} ${c.border} ${c.hoverBorder} ${c.hover}`}
              >
                <div className={`w-10 h-10 md:w-11 md:h-11 rounded-xl flex items-center justify-center ${c.iconBg}`}>
                  <i className={`${item.icon} ${c.icon} text-lg md:text-xl`}></i>
                </div>
                <h3 className="mt-3 font-heading font-bold text-sm md:text-base text-foreground-900">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">{item.desc}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className={`text-xs font-bold ${c.count}`}>{item.count}部</span>
                  <i className="ri-arrow-right-line text-foreground-300 group-hover:translate-x-1 transition-transform text-sm"></i>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}